jQuery(document).ready(function() {
    
    window.cookieconsent.initialise({

        "palette": {
        "popup": {
            "background": "#0882c6",
            "text": "#ffffff",
        },
        "button": {
            "background": "#ffffff",
            "text": "#0882c6",
        }
        },
        "position": "bottom-left",
        "content": {
        "message": "Vi använder cookies för att ge dig den bästa upplevelsen av vår webbplats.",
        "dismiss": "Jag förstår!",
        "link": "Läs mer",
        "href": "https://www.ju-jutsukai.se/integritetspolicy/",
        "target": "_self"
        }

    });

});